function loadCartDrawerPromoSlider() {
  const slidesContainer = document.querySelector(".js-message-slider__slides");
  if (slidesContainer) {
    const dots = document.querySelectorAll(".message-slider__dot");
    let currentIndex = 0;

    function changeSlide(index) {
      dots[currentIndex].classList.remove("message-slider__dot--active");
      currentIndex = index;
      dots[currentIndex].classList.add("message-slider__dot--active");
      slidesContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => changeSlide(index));
      dot.addEventListener("click", () => changeSlide(index));
    });

    setInterval(() => {
      let nextIndex = (currentIndex + 1) % dots.length;
      changeSlide(nextIndex);
    }, 4000);
  }
}


document.addEventListener('on:cart-drawer:before-open', loadCartDrawerPromoSlider);